export default __webpack_public_path__ + "ae450151076702f77601bc57f2ad406a.png";